module.exports = __webpack_public_path__ + "img/spinner.4a5a4278.svg";